export const PropertyColorsData = {
  grey: 'white',
  blue: 'white',
  orange: 'white',
  green: 'white',
  red: 'white',
  purple: 'white',
  pink: 'white',
  teal: 'white',
  black: 'white',
  white: 'black',
  beige: 'beige',
} as const;

export const PropertyColors = [
  'grey',
  'blue',
  'orange',
  'green',
  'red',
  'purple',
  'pink',
  'teal',
  'black',
  'white',
  'beige',
] as const;

export type PropertyColor = (typeof PropertyColors)[number];

export const DefaultPropertyColor = 'blue';
